/* unplugin-vue-components disabled */import script from "./ProductPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductPreviewModal.vue?vue&type=style&index=0&id=0e61a602&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e61a602"]])

export default __exports__